export const analyticsDashboardAppGroupIdCreditConsumptionTimePeriodData =
  "/analytics_dashboard/:app_group_id/credit_consumption_time_period_data";
